import React from "react";
import { connect } from "react-redux";
import { cargarReembolsos } from "./seguimiento.act";
import DetalleReembolso from "./detalleReembolso.cmpt";

const mapState = (state) => {
	return {
		polizas: state.polizas.gm,
		reembolsos: state.siniestros.sreembolsos,
		original: state.siniestros.originalReembolsos,
		"lastlogin": state.global.lastlogin
	};
};

const mapDispatch = (dispatch) => {
	return {
		cargarReembolsos: (polizas) => {
			dispatch(cargarReembolsos(polizas));
		},
		setSelect: (reembolso) => {
			dispatch({"type": "SINIESTROS_SET_SELECT_REM", "select": reembolso});
		},
		refresh: (siniestros) => {
			dispatch({"type": "SINIESTROS_SET_SINIESTROSREMACT", "sreembolsos": siniestros});
		},
		addEvento: (evento) => {
			dispatch({"type": "SINIESTROS_SET_EVENT", "evento": evento});
		}
	};
};

export class SeguimientoRembolsos extends React.Component {
	state = {
		verDetalle: false,
		busqueda: false
	}
	
	fncVerDetalle = (reembolso) => {
		$('#returnPageSiniestros').show();
		this.props.setSelect(reembolso);
		this.setState({ "verDetalle": true });
		this.props.addEvento("CardSReembolso");
	}
	
	componentDidMount(){
	    $(document).ready(()=>{
		    $('#returnPageSiniestros').on('click',()=>{
		         $('#returnPageSiniestros').hide();
		        this.setState({ "verDetalle": false });
		    });
		});
	}
	
	componentWillReceiveProps = (nextProps) => {
		if(this.props.polizas != nextProps.polizas)
		{
			var lista_polizas = this.props.polizas;
			let polizas = [];
			if (lista_polizas.length) {
				for (var pol of lista_polizas)
				{
				  let asegurados = [];
				  for(var as of pol.asegurados)
				  {
				  	asegurados.push({"certificado" : as.certificado, "idParticipante" : as.idParticipante});
				  }
				 polizas.push({"poliza" : pol.generales.numPoliza, "cveSistema" : pol.generales.cveSistema, "asegurados" : asegurados});
				}
			}
			this.props.cargarReembolsos(polizas);
		}
	}
	
	componentWillMount = () => {
		 console.log(this.props.polizas);
		 var lista_polizas = this.props.polizas;
		 let polizas = [];
		 if (lista_polizas.length) {
			 for (var pol of lista_polizas)
			 {
			 	 let asegurados = [];
			 	 for(var as of pol.asegurados)
			 	 {
			 	 	asegurados.push({"certificado" : as.certificado, "idParticipante" : as.idParticipante});
			 	 }
				 polizas.push({"poliza" : pol.generales.numPoliza, "cveSistema" : pol.generales.cveSistema, "asegurados" : asegurados});
			 }
		 }
		 this.props.cargarReembolsos(polizas);
	}
	
	clickBuscar = () => {
		this.props.addEvento("Buscador-SReembolsos");
	}
	
	handleChange = (event) => {
		console.log("entro al handleChange");
        let filtro = event.target.value;
        let siniestros = [];
        
        this.setState({
        	"busqueda" : true
        });
        
        if(filtro == ""){
        	siniestros = this.props.original;
        }
        else
        {
        	this.props.original.map((item, i) => {
	        	if(item.numSolicitud.indexOf(filtro) != -1 || item.idTransaccion.indexOf(filtro) != -1)
	        	{
	        		siniestros.push(item);
	        	}
        	})
        }
        
        console.log(siniestros);
        this.props.refresh(siniestros);
    };

	render() {
		return <div className="container siniestros-container">
			<h6><small><b>Infomación Actualizada al:</b> { this.props.lastlogin }</small></h6>
			{ !this.state.verDetalle && (this.props.reembolsos.length > 0 || this.state.busqueda) &&
			<div>
				<div className="rembolsos-title">
					<div className="rembolsos-h4">
						<h4>Reembolsos</h4>
						<h4>{this.props.reembolsos.length}</h4>
					</div>
					<div className="filtro-siniestros">
						<label>Filtrar por folio o SIGREE</label>
						<input className="search" type="text" onClick={this.clickBuscar} onChange={this.handleChange}></input>
					</div>
				</div>
				<div className="siniestros-card-wrapper">
				{this.props.reembolsos.map((item, i) => 
					<div key={i} className="card siniestro-card select-card" onClick={this.fncVerDetalle.bind(this,item)}>
						<img src={require("../img/siniestros-rembolsos.svg")}></img>
						<div className="reporte-desc">
							<p><span>No. Póliza: </span>{item.numPoliza}</p>
							<p><span>No. Folio: </span> {item.numSolicitud}</p>
							<p><span>SIGREE:</span> {item.idTransaccion}</p>
							<p className="status"><span></span>
							{item.idEstadoTramitePago == "16" &&
								"Dictamen"
							}
							{item.idEstadoTramitePago == "10" &&
								"En Proceso"
							}
							{item.idEstadoTramitePago == "30" &&
								"Cerrado"
							}
							{item.idEstadoTramitePago == "64" &&
								"Cancelado"
							}
							</p>
						</div>
					</div>
				)}
				</div>
			</div>
			}
			{ this.state.verDetalle &&
				 <DetalleReembolso/>
			}
			{ this.props.reembolsos.length == 0 && !this.state.busqueda &&
			<div className="sin-polizas-container">
				<div className="sin-polizas-wrap">
					<img src={require("../img/sin-polizas-icon.png")} />
					<span style={{"color":"#183d7b"}}>No hay reembolsos</span>
					<p>Por el momento no cuentas con trámites</p>
				</div>
			</div>
			}
		</div>;
	}
}

export default connect(mapState,mapDispatch)(SeguimientoRembolsos);


// WEBPACK FOOTER //
// ./src/seguimiento-siniestros/seguimientoReembolsos.cmpt.js